<div class="p-7 bg-lightest">
  <div class="flex md:inline">
    <button
      pButton
      class="back-connexion font-app-medium"
      [routerLink]="['/connexion']">
      <i class="pi pi-arrow-left mr-4"></i>
    </button>
    <h1 class="flex md:justify-center text-xl md:text-4xl font-app-bold mb-5 md:mb-10">
      {{ "passwordMessages.forgotPassword" | translate }}
    </h1>
  </div>
  <div class="bg-white rounded-lg border-light border shadow-none px-5 pt-5 pb-10 lg:w-1/2 mt-4 md:mt-10 mx-auto">
    <h2 class="text-2xl font-bold text-darkest font-app-bold mb-5">
      {{ "passwordMessages.forgotPasswordSubtitle" | translate }}
    </h2>
    <p class="mb-5 text-dark">{{ "passwordMessages.forgotPasswordInfo" | translate }}</p>
    <form
      [formGroup]="formGroup"
      *ngIf="!isEmailSent; else emailSent">
      <div>
        <label
          class="font-app-regular"
          for="email"
          >{{ "passwordMessages.email" | translate }}</label
        >
        <input
          pInputText
          type="email"
          id="email"
          formControlName="email"
          required
          class="w-full border-2 border-light mt-1 p-3"
          [placeholder]="'passwordMessages.enterEmail' | translate" />
        <small
          class="p-error"
          *ngIf="email?.touched && email?.invalid && (email?.errors)!['required']">
          {{ "passwordMessages.enterEmail" | translate }}
        </small>
        <small
          class="p-error"
          *ngIf="email?.touched && ((email?.invalid && (email?.errors)!['pattern']) || showUnknown)">
          {{ "passwordMessages.emailInvalid" | translate }}
        </small>
      </div>
      <div class="mt-10 text-center md:text-left">
        <button
          pButton
          label="Envoyer un mail"
          type="submit"
          class="block md:table-cell rounded-md py-3 px-5 bg-primary text-white w-full"
          [disabled]="!emailExists"
          [loading]="loading"
          (click)="sendEmail()"></button>
      </div>
    </form>
    <ng-template #emailSent>
      <div class="color-low font-bold flex justify-center items-center color-green">
        <i class="pi pi-check mr-2"></i>
        {{ "passwordMessages.emailSent" | translate }}
      </div>
    </ng-template>
  </div>

  <app-info-card
    [className]="'lg:w-1/2 mt-4 md:mt-10 mx-auto'"
    [title]="'passwordMessages.resetPassword' | translate"
    [message]="'passwordMessages.sendEmailResetPwd' | translate"></app-info-card>
</div>
